/*
 * Copyright (c) 2025 SARL SIGMA POLYNESIA
 */

import fr from '../../client/locales/fr.json'
import en from '../../client/locales/en.json'

const messages: Record<string, Record<string, string>> = {
  en,
  fr
}

export const getMessages = (locale: string) => messages[locale] ?? messages[locale.substring(0, 2)]

export default messages
